import { render, staticRenderFns } from "./fileField.vue?vue&type=template&id=3483f4a8&scoped=true&lang=pug&"
import script from "./fileField.vue?vue&type=script&setup=true&lang=js&"
export * from "./fileField.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./fileField.vue?vue&type=style&index=0&id=3483f4a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3483f4a8",
  null
  
)

export default component.exports